import { Map } from "immutable";
import actions from "./actions";

const initState = new Map({ token: null });

export default function authReducer(state = initState, action) {
  switch (action.type) {
    case actions.LOGIN_SUCCESS:
      return state.set("token", action.token);
    default:
      return state;
  }
}
